import dayjs from 'dayjs';
import { EventType, GetActivityHistoryQuery } from '../client/generated/graphql';
import { i18next } from '../i18n';
import { toDueDate } from './datetime';

export const groupEventsByDate = (events: GetActivityHistoryQuery['eventLogs']) => {
    const grouped: Record<string, GetActivityHistoryQuery['eventLogs']> = {};

    events.forEach(event => {
        const date = dayjs(event.createdAt).format('YYYY-MM-DD');
        if (!grouped[date]) {
            grouped[date] = [];
        }
        grouped[date].push(event);
    });

    return Object.entries(grouped)
        .sort(([a], [b]) => dayjs(b).diff(dayjs(a)))
        .map(([date, events]) => ({
            date,
            displayDate: toDueDate(dayjs(date), false),
            events,
        }));
};

export const formatTimeSpent = (timeInMs?: number | null, timeInSec?: number | null): string | null => {
    if (!timeInMs && !timeInSec) return null;

    const totalSeconds = timeInMs ? Math.floor(timeInMs / 1000) : timeInSec || 0;

    if (totalSeconds < 60) return null; // Don't show if less than 1 minute

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    if (hours > 0 && minutes > 0) {
        return `${i18next.t('duration.hoursShort', { count: hours })} ${i18next.t('duration.minutesShort', { count: minutes })}`;
    } else if (hours > 0) {
        return i18next.t('duration.hoursShort', { count: hours });
    } else if (minutes > 0) {
        return i18next.t('duration.minutesShort', { count: minutes });
    }

    return null;
};

export const getEventColor = (eventType: EventType) => {
    switch (eventType) {
        case EventType.QuestCompleted:
            return 'var(--tg-theme-button-color)';
        case EventType.QuestMetricIncreased:
            return 'var(--tg-theme-accent-text-color)';
        case EventType.GoalCompleted:
            return '#ffd700'; // Gold for achievements
        case EventType.RewardPurchased:
            return '#9c27b0'; // Purple for purchases
        default:
            return 'var(--tg-theme-hint-color)';
    }
};
